import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchUnidentifiedOperatorsOperation({ unidentifiedOperatorsOperationParams }) {
  try {
    yield put(Actions.setUnidentifiedOperatorsOperationLoaderStatus({ unidentifiedOperatorsOperationLoader: true }));
    const { data } = yield call(api.get, {
      route: 'labour/GetUnidentifiedOperators',
      params: unidentifiedOperatorsOperationParams,
    });
    const unidentifiedOperatorsData = data;
    yield put(Actions.setUnidentifiedOperatorsOperation({ unidentifiedOperatorsData }));
    yield put(Actions.setUnidentifiedOperatorsOperationLoaderStatus({ unidentifiedOperatorsOperationLoader: false }));
  } catch (err) {
    yield put(Actions.setUnidentifiedOperatorsOperationLoaderStatus({ unidentifiedOperatorsOperationLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateUnidentifiedOperator({ unidentifiedOperatorsObj, unidentifiedOperatorsOperationParams }) {
  try {
    yield put(Actions.setUnidentifiedOperatorsOperationLoaderStatus({ unidentifiedOperatorsOperationLoader: true }));
    yield call(api.put, {
      route: `unidentifiedOperator`,
      data: unidentifiedOperatorsObj,
    });
    yield put(Actions.fetchUnidentifiedOperatorsOperation({ unidentifiedOperatorsOperationParams }));
    notification('success', CONSTANT_VARIABLES.UNIDENTIFIED_OPERATOR_UPDATED, '');
  } catch (err) {
    yield put(Actions.setUnidentifiedOperatorsOperationLoaderStatus({ unidentifiedOperatorsOperationLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* trackerExist({ trackerId }) {
  try {
    yield put(Actions.setTrackerExistLoaderStatus({ trackerExistLoader: true }));
    const { data } = yield call(api.get, {
      route: `labour/istrackereidxists/${trackerId}`,
    });
    const trackerExistsData = data;
    yield put(Actions.setTrackerExist({ trackerExistsData }));
    yield put(Actions.setTrackerExistLoaderStatus({ trackerExistLoader: false }));
  } catch (err) {
    yield put(Actions.setTrackerExistLoaderStatus({ trackerExistLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchOperatorById({ operatorId }) {
  try {
    yield put(Actions.setOperatorByIdLoaderStatus({ operatorByIdLoader: true }));
    const { data } = yield call(api.get, {
      route: `labour/${operatorId}`,
    });
    const operatorData = data;
    yield put(Actions.setOperatorById({ operatorData }));
    yield put(Actions.setOperatorByIdLoaderStatus({ operatorByIdLoader: false }));
  } catch (err) {
    yield put(Actions.setOperatorByIdLoaderStatus({ operatorByIdLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_UNIDENTIFIED_OPERATORS_OPERATION, fetchUnidentifiedOperatorsOperation),
    takeLatest(ActionTypes.UPDATE_UNIDENTIFIED_OPERATORS_OPERATION, updateUnidentifiedOperator),
    takeLatest(ActionTypes.FETCH_TRACKER_EXIST_OPERATION, trackerExist),
    takeLatest(ActionTypes.FETCH_OPERATOR_BY_ID, fetchOperatorById),
  ]);
}
